module.exports = __webpack_public_path__ + "static/media/recommend.e738e819.svg";